import { DateTime } from 'luxon'
import { getEffectiveTimezone } from './getEffectiveTimezone'

// The API takes a calendar date and the time of day separately, so this never converts through UTC, which would shift the day.
export const resolveEventDateOnly = (
  eventDate?: string | null,
  zone?: string | null
): string | null => {
  const normalizedDate = (eventDate ?? '').trim()
  if (!normalizedDate) return null

  const parsed = DateTime.fromISO(normalizedDate, { zone: getEffectiveTimezone(zone) })
  return parsed.isValid ? parsed.toFormat('yyyy-MM-dd') : null
}
